import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/Home'
import About from '../pages/About'
import Books from '../pages/Books'
import Detail from '../pages/Detail'
import BooksDb from '../pages/BooksDb'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', component: Home },
    {
      path: '/about',
      component: About,
      children: [
        {
          path: '/about/detail/:sno',
          component: Detail,
          props: true
        }
      ]
    },
    { path: '/books', component: Books },
    { path: '/booksDb', component: BooksDb }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js